import React from 'react';
import { RecallItems } from '../../../services/recalls-service/recalls-service';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import { ExemptWordsListProps } from '../../pages/recalls/hook/use-exempt-word-list';
import RecallActionBanner from '../recalls-action-banner/recall-action-banner';
import { recallsToLowerCase } from '../recalls-button/recalls-button';
import './recall-report.scss';

interface Props {
    recall: RecallItems;
    content: RecallsUnitedContent;
    exemptWordsList?: ExemptWordsListProps | null;
    isCsp: boolean;
    onKeyDown?: (event: any) => void;
    vin?: string | null;
    desktopOrLarger?: boolean;
    isWebview: boolean;
}

function RecallReport(props: Props) {
    const {
        recall,
        content,
        exemptWordsList,
        isCsp,
        onKeyDown,
        isWebview,
        vin,
    } = props;
    const remedyNotAvailable =
        typeof recall.remedyAvailable !== 'undefined' &&
        (recall.remedyAvailable === 'false' || !recall.remedyAvailable) &&
        !!content?.recallRemedyNotAvailableTitle &&
        !!vin;

    return (
        <section
            tabIndex={0}
            className="recall-report-container"
            onKeyDown={onKeyDown}
        >
            <h2 className="recalls-modal-h2">
                {recallsToLowerCase(recall.descriptionLang, exemptWordsList)}
            </h2>
            {!isCsp && (
                <div className="recall-incomplete-modal-label">
                    {content.recallIncompleteLabel}
                </div>
            )}
            <RecallActionBanner
                content={content}
                isCsp={isCsp}
                recall={recall}
                vin={vin}
                desktopOrLarger={props.desktopOrLarger}
                isWebview={isWebview}
                remedyNotAvailable={remedyNotAvailable}
            />
            <div className="recalls-date-and-campaign">
                {recall.recallDate && (
                    <div className="recall-info-piece">
                        <div className="recall-info-piece-label">
                            {content.dateLabel}
                        </div>
                        <div className="recall-info-piece-data">
                            {recall.recallDate}
                        </div>
                    </div>
                )}
                <div className="recall-info-piece">
                    <div className="recall-info-piece-label">
                        {content.campaignLabel}
                    </div>
                    <div className="recall-info-piece-data">
                        {recall.fsaNumber
                            ? recall.fsaNumber
                            : `${recall.manufacturerRecallNumber}/${recall.nhtsaRecallNumber}`}
                    </div>
                </div>
            </div>
            <div className="recall-info-piece">
                <div className="recall-info-piece-label">
                    {content.descriptionLabel}
                </div>
                <div className="recall-info-piece-data">
                    {recallsToLowerCase(
                        isCsp
                            ? recall.descriptionLang
                            : recall.recallDescriptionLang,
                        exemptWordsList
                    )}
                </div>
            </div>
            {recall.safetyRiskDescriptionLang && (
                <div className="recall-info-piece">
                    <div className="recall-info-piece-label">
                        {content.safetyRiskLabel}
                    </div>
                    <div className="recall-info-piece-data">
                        {recallsToLowerCase(
                            recall.safetyRiskDescriptionLang,
                            exemptWordsList
                        )}
                    </div>
                </div>
            )}
            {recall.remedyDescriptionLang?.trim() && (
                <div className="recall-info-piece">
                    <div className="recall-info-piece-label">
                        {content.remedyLabel}
                    </div>
                    <div className="recall-info-piece-data">
                        {recallsToLowerCase(
                            recall.remedyDescriptionLang,
                            exemptWordsList
                        )}
                    </div>
                </div>
            )}
            {!remedyNotAvailable && (
                <div className="recall-info-piece">
                    <div className="recall-info-piece-label">
                        {content.nextStepsLabel}
                    </div>
                    <div className="recall-info-piece-data">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: isCsp
                                    ? content.nextStepsCsp
                                    : content.nextStepsRecalls,
                            }}
                        />
                    </div>
                </div>
            )}
        </section>
    );
}

export default RecallReport;
